@let borderRadius = this.borderRadius();
<div class="border"></div>
<div class="left" [style.borderBottomLeftRadius]="borderRadius" [style.borderTopLeftRadius]="borderRadius"></div>
<div class="right" [style.borderBottomRightRadius]="borderRadius" [style.borderTopRightRadius]="borderRadius"></div>
